import { Policy } from '@summit/core';

import { DayOfWeek } from '../c-types';

export class IProfile {
  id?: string;
  tenantID?: string;
  fedExID?: string;
  roles: unknown;
  endOfWeek?: DayOfWeek;
  endOfScheduleWeek?: DayOfWeek;
  endOfIvmrWeek?: DayOfWeek;

  hasPermissions(_permissionsNeeded: Policy): boolean {
    return true;
  }
}
